
export default {
  name: "Stepper",
  props: {
    steps: Array,
    active: [String, Number],
  }
}
